const pageNameKey = "blueprintStateInfoBannerRestructuringSummaryWrapper";

export const blueprintStateInfoBannerRestructuringSummaryWrapperEn = {
  [pageNameKey]: {
    summaryContainerTitle: "Restructuring Summary",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperPtBr = {
  [pageNameKey]: {
    summaryContainerTitle: "Resumo da reestruturação",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperDe = {
  [pageNameKey]: {
    summaryContainerTitle: "Zusammenfassung der Umstrukturierung",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperZhHans = {
  [pageNameKey]: {
    summaryContainerTitle: "重组摘要",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperIt = {
  [pageNameKey]: {
    summaryContainerTitle: "Sintesi della riorganizzazione",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperEs = {
  [pageNameKey]: {
    summaryContainerTitle: "Resumen de la reestructuración",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperNl = {
  [pageNameKey]: {
    summaryContainerTitle: "Samenvatting herstructurering",
  },
};

export const blueprintStateInfoBannerRestructuringSummaryWrapperTr = {
  [pageNameKey]: {
    summaryContainerTitle: "Yeniden Yapılanma Özeti",
  },
};
